import React, { Component } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./style.css";

export default class DatePickerComp extends Component {
  state = {
    shouldShowAutoComplete: false,
    date: null,
  };

  render() {
    console.log(this.props);
    const {
      placeholder,
      inputClasses = "",
      onChange = function () {},
      value,
      selected,
      isError = false,
      errorMessage = "",
      maxDate = null,
    } = this.props;

    return (
      <>
        <DatePicker
          selected={this.state.date}
          placeholderText={placeholder}
          maxDate={maxDate}
          wrapperClassName="date-picker-wrapper"
          className={`${inputClasses} date-picker ${
            isError ? "is-error " : ""
          }`}
          onChange={onChange}
          value={value}
          selected={selected} //eslint-disable-line
        />
        <p hidden={isError ? false : true} className={"is-error-text"}>
          {errorMessage}
        </p>
      </>
    );
  }
}
